import React from 'react';

export default function MetricToggle({ value, onChange }) {
  const options = [
    { key: 'monto', label: 'Desembolso' },
    { key: 'total', label: 'Total a pagar' },
  ];

  return (
    <div className="inline-flex rounded-xl border border-slate-200 bg-slate-100 p-1">
      {options.map((opt, idx) => {
        const active = value === opt.key;
        return (
          <button
            key={opt.key}
            type="button"
            onClick={() => onChange(opt.key)}
            className={[
              'rounded-lg px-4 py-2 text-sm font-semibold focus:outline-none transition',
              active
                ? 'bg-white text-red-600 shadow-sm'
                : 'text-slate-600 hover:bg-white/70 hover:text-slate-800',
              idx !== options.length - 1 ? 'mr-1' : '',
            ].join(' ')}
            aria-pressed={active}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
